import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import Profile from '../../Models/Profile';
import Common from "../../Models/Common";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class BuyerSidebar extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            minHeight: "475px",
            modalIsOpen: false,
            user: logged_user,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleLogout(e) {
        e.preventDefault();
        window.localStorage.removeItem('info')
        localStorage.clear();
        // this.props.history.push('/');
        window.location.href = '/';
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={Common.baseUrl + pro_pic} style={{width: "170px", height: "170px", objectFit: 'cover', borderRadius: '50%' }} />
                </div>
            )
        } else {
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={Common.baseUrl + x.img_sidebar} style={{ width: "170px", height: "170px", objectFit: 'cover', borderRadius: '50%' }} />
                </div>
            )
        }
    }
    profileName() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var pro_name = JSON.parse(localStorage.getItem('pro_name'))
            console.log(pro_name)
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{pro_name}</span>
                </div>
            )
        } else {
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{this.state.user.first_name}</span>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    {this.profilePic()}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name">{this.state.user.first_name}</span>
                    </div>

                    <Link to={{
                        pathname: 'buyer-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">{this.props.t('1')}</span>
                    </Link>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    {this.profilePic()}
                    {this.profileName()}
                    {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name">{this.state.user.first_name}</span>
                    </div> */}

                    <Link to={{
                        pathname: 'buyer-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">{this.props.t('1')}</span>
                    </Link>
                    <div className="mt-3 mb-3  input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }}>
                        {this.props.t('7')}
                </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-transaction'} className="color_alt sidebar_font">{this.props.t('8')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-request-home'} className="color_alt sidebar_font">{this.props.t('3')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-dashboard'} className="color_alt sidebar_font" >{this.props.t('9')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-favorites'} className="color_alt sidebar_font">{this.props.t('4')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/followers-buyer'} className="color_alt sidebar_font">{this.props.t('10')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-direct-message-list'} className="color_alt sidebar_font">{this.props.t('5')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-change-password'} className="color_alt sidebar_font">{this.props.t('0')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'#'} onClick={this.handleLogout.bind(this)} className="color_alt sidebar_font">{this.props.t('6')}</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }
}
export { BuyerSidebar }


 BuyerSidebar = withTranslation('src_Components_Common_BuyerSidebar')(BuyerSidebar);
